<template>
  <div
    class="panel-modal-footer flex border-t border-zinc-200/70 bg-zinc-50/80 px-6 py-4 dark:border-zinc-800 dark:bg-zinc-900/60"
  >
    <slot />
  </div>
</template>

<script>
export default {
  //
}
</script>
